import { Button, Spin } from "antd";
import CheckboxInput from "components/Form/CheckboxInput";
import LabeledInput from "components/Form/LabeledInput";
import LabeledSelectInput from "components/Form/LabeledSelectInput";
import LabeledUploadInput from "components/Form/LabeledUploadInput";
import WindIcon from "components/Icons/WindIcon";
import useEditFleet from "hooks/fleets/useEditFleet";

export default function EditFleet() {
  const {
    control,
    handleSubmit,
    fleetModels,
    loading: { button, page },
    onSubmit,
    handleUploadFleetImage,
    handleUploadLicenseImage,
  } = useEditFleet();

  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full pt-5 pb-5">
        <div className="w-full">
          <h1 className="p-5 font-light text-lg text-center">Edit Fleet</h1>
          <div className="w-full">
            <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
              <div className="w-1/2 bg-black h-full rounded-md"></div>
            </div>
            <div className="relative w-full flex justify-center">
              <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
                <WindIcon />
              </div>
            </div>
          </div>
          <p className="text-center mt-2 text-sm font-normal">
            Fleet Information
          </p>
        </div>
        <div className="w-full py-8 px-5">
          {page ? (
            <div className="w-full flex items-center justify-center py-20">
              <Spin />
            </div>
          ) : (
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="w-full flex flex-wrap"
            >
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet Brand"
                  type="text"
                  control={control}
                  name="brand"
                  placeholder="Fleet Brand"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet Model"
                  type="text"
                  control={control}
                  name="model"
                  placeholder="Fleet Model"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet Color"
                  type="text"
                  control={control}
                  name="color"
                  placeholder="Fleet Color"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledSelectInput
                  label="Fleet Type"
                  control={control}
                  loading={fleetModels.loading}
                  name="fleet_model_id"
                  placeholder="Select Fleet Type"
                  options={fleetModels.data.map((value) => ({
                    value: value.id,
                    label: value.name,
                  }))}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledSelectInput
                  label="Fleet Category"
                  control={control}
                  name="category"
                  placeholder="Select Fleet Category"
                  options={[
                    { label: "Engine", value: "Engine" },
                    { label: "EV", value: "EV" },
                    { label: "Megala", value: "Megala" },
                    { label: "Proto", value: "Proto" },
                    { label: "Bajaj", value: "Bajaj" },
                    { label: "Proto Megala", value: "Proto Megala" },
                    { label: "Megala Engine", value: "Megala Engine" },
                    { label: "Megala EV", value: "Megala EV" },
                    { label: "Proto Engine", value: "Proto Engine" },
                    { label: "Proto EV", value: "Proto EV" },
                  ]}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet plate number"
                  type="text"
                  control={control}
                  name="plate_number"
                  placeholder="Fleet plate number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet license number"
                  type="text"
                  control={control}
                  name="license_number"
                  placeholder="Fleet license number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet brand number"
                  type="text"
                  control={control}
                  name="brand_number"
                  placeholder="Fleet brand number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet production year"
                  type="number"
                  min="1980"
                  max={new Date().getFullYear()}
                  control={control}
                  name="production_year"
                  placeholder="Fleet production year"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet door number"
                  type="text"
                  control={control}
                  name="door_number"
                  placeholder="Fleet door number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Fleet passenger seat"
                  type="text"
                  control={control}
                  name="passenger_seat"
                  placeholder="Fleet passenger seat"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="image"
                  placeholder="Select Fleet Image"
                  label="Fleet Image"
                  action={handleUploadFleetImage}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledUploadInput
                  control={control}
                  name="license_image"
                  placeholder="Select Fleet License Image"
                  label="Fleet License Image"
                  action={handleUploadLicenseImage}
                />
              </div>
              <div className="w-full px-4 pt-5">
                <CheckboxInput
                  control={control}
                  name="has_tinted_windows"
                  title="Has Tinted Windows"
                />
              </div>
              <div className="w-full px-4 pt-5">
                <CheckboxInput control={control} name="has_ac" title="Has Ac" />
              </div>
              <div className="w-full flex mt-8 justify-end">
                <Button
                  loading={button}
                  htmlType="submit"
                  type="primary"
                  className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
                >
                  Update Fleet
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
